<template>
    <Content class="modal fade" :id="modal_id">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </Content>
</template>

<script>
import { Content } from "./style";

export default {
    name: "ModalCalendar",
    props: {
        modal_id: { required: true, type: String },
    },
    components: {
        Content,
    },
};
</script>
